export class LayerUIFactory {
    constructor() { }
    static construct_ui_for(layer) {
        const cls_string = layer.visible ? 'layer active' : 'layer';
        const ui_parent = $(`<div class="${cls_string}"></div>`);
        const input = LayerUIFactory.construct_input(layer);
        input.on('click', (e) => {
            layer.visible = e.target.checked;
            if (layer.is_base)
                ui_parent.trigger('base_layer_select', [layer.name, layer.visible]);
            ui_parent.toggleClass('active', layer.visible);
        });
        const label = LayerUIFactory.construct_label(layer, input);
        ui_parent.append(label);
        if (!layer.is_base)
            ui_parent.append(LayerUIFactory.construct_opacity_select(layer));
        return ui_parent;
    }
    static construct_label(layer, input) {
        const cursor_style = layer.is_base && layer.visible ? 'default' : 'pointer';
        const element = $(`<label style="cursor:${cursor_style};"></label>`);
        const name_elem = $(`<span style="vertical-align:baseline;margin-left:8px;">${layer.name}</span>`);
        element.append(input);
        element.append(name_elem);
        return element;
    }
    static construct_input(layer) {
        const typ = layer.is_base ? 'radio' : 'checkbox';
        const id = layer.name.replace(/\s/g, '');
        const name = layer.is_base ? 'baseLayers' : layer.name;
        const element = $(`<input type="${typ}" id="${id}" name="${name}" value="${id}" />`);
        element.prop('checked', layer.visible);
        return element;
    }
    static construct_opacity_select(layer) {
        const select = $('<select></select>');
        const range = Array.from(Array(11).keys());
        const options = range.map(value => value * 10).map(value => $(`<option value="${value / 100}">${value}</option>`));
        for (let opt of options)
            select.append(opt);
        select.on('change', (e) => {
            layer.opacity = parseFloat(e.target.value);
        });
        select.prop('value', layer.opacity);
        return select;
    }
}
